import { useEffect } from "react";

/**
 * @component PreventScreenshot
 * @description
 * Componente React que intenta prevenir capturas de pantalla mediante la tecla "PrintScreen".
 * 
 * Cuando el usuario presiona la tecla `PrintScreen`, este hook oculta temporalmente
 * el contenido del `body` durante 1 segundo para disuadir la captura de pantalla.
 * 
 * ⚠️ Nota: Este método no garantiza la protección absoluta contra capturas, ya que no puede bloquear 
 * herramientas externas o de sistema operativo.
 *
 * @returns {null} Este componente no renderiza ningún elemento en el DOM.
 */
const PreventScreenshot = () => {
	useEffect(() => {
		/**
		 * Oculta temporalmente el contenido al presionar la tecla "PrintScreen".
		 * @param {KeyboardEvent} event
		 */
		const handlePrintScreen = (event) => {
			if (event.key === "PrintScreen") {
				document.body.style.visibility = "hidden";
				setTimeout(() => {
					document.body.style.visibility = "visible";
				}, 1000);
			}
		};

		document.addEventListener("keydown", handlePrintScreen);

		// Limpieza del listener al desmontar el componente
		return () => {
			document.removeEventListener("keydown", handlePrintScreen);
		};
	}, []);

	return null;
};

export default PreventScreenshot;